import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=2ae36223&scoped=true&"
import script from "./Tracking.vue?vue&type=script&lang=ts&"
export * from "./Tracking.vue?vue&type=script&lang=ts&"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=2ae36223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae36223",
  null
  
)

export default component.exports